import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import { t } from "i18next";
import { FC } from "react";
import { GrideDateFormatter } from "ui/Date";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";

// export const frozenSaleWeeklyGridColumn = () => {
// 	const gridItems: GridColumnProps[] = [
// 		{
// 			//This wont show up
// 			field: "id",
// 			title: "Salgs nr",
// 		},

// 		{
// 			field: "vesselName",
// 			title: t("VesselName"),
// 			cell: (props) => <CellPopover {...props} />,
// 			width: "170px",
// 		},

// 		{
// 			field: "fishingGearText",
// 			title: t("FishingGear"),
// 			width: "100px",
// 		},
// 		{
// 			field: "productText",
// 			title: t("Product"),
// 			cell: (props) => <CellPopover {...props} />,
// 		},
// 		{
// 			field: "netLiveWeightKg",
// 			title: t("Weight"),
// 			width: "120px",
// 			cell: (props) => (
// 				<NumericalCell {...props} unit={"kg"} formatDecimal={2} />
// 			),
// 			footerCell: (props) => {
// 				console.log(props);
// 				return (
// 					<td
// 						className="k-table-td"
// 						colSpan={props.colSpan}
// 						style={props.style}
// 						role={"gridcell"}
// 					>
// 						Sum: 50
// 					</td>
// 				);
// 			},

// 			headerClassName: CLASSNAME.TableNumeric,
// 			className: `${CLASSNAME.TableNumeric} no-border`,
// 			headerCell: (props) => <NumericalHeader {...props} />,
// 		},
// 		{
// 			field: "price",
// 			title: t("Price"),
// 			width: "120px",
// 			cell: (props) => (
// 				<NumericalCell {...props} unit={"kr"} formatDecimal={2} />
// 			),
// 			headerClassName: CLASSNAME.TableNumeric,
// 			className: `${CLASSNAME.TableNumeric} no-border`,
// 			headerCell: (props) => <NumericalHeader {...props} />,
// 		},
// 		{
// 			field: "averagePrice",
// 			title: t("AveragePrice"),
// 			width: "120px",
// 			cell: (props) => (
// 				<NumericalCell {...props} unit={"kr"} formatDecimal={2} />
// 			),
// 			headerClassName: CLASSNAME.TableNumeric,
// 			className: `${CLASSNAME.TableNumeric} no-border`,
// 			headerCell: (props) => <NumericalHeader {...props} />,
// 		},
// 		{
// 			field: "msc",
// 			title: "msc",
// 			width: "100px",
// 		},

// 		{
// 			field: "information",
// 			title: t("Information"),
// 			cell: (props) => <CellPopover {...props} />,
// 		},
// 		{
// 			field: "buyerName",
// 			title: t("BuyerName"),
// 			cell: (props) => <CellPopover {...props} />,
// 		},
// 		{
// 			field: "salesDate",
// 			title: t("Date"),
// 			width: "110px",
// 			headerClassName: "no-border",
// 			cell: (props) => (
// 				<GrideDateFormatter
// 					date={props.dataItem.landingTime}
// 					formatType={"dd.MM.yyyy"}
// 				/>
// 			),
// 		},
// 		{
// 			field: "salesWeekDay",
// 			title: t("WeekDay"),
// 			width: "150px",
// 		},

// 		{
// 			field: "salesType",
// 			title: t("Type"),
// 			cell: (props) => <CellPopover {...props} />,
// 		},
// 	];
// 	return gridItems;
// };

export const frozenSaleWeeklyGridColumn = (): GridColumnProps[] => {
	return [
		{
			field: "vesselName",
			title: t("VesselName"),
			cells: { data: (props) => <CellPopover {...props} /> },
			width: "200px",
		},
		{
			field: "fishingGearText",
			title: t("FishingGear"),
			width: "100px",
		},
		{
			field: "productText",
			title: t("Product"),
			minResizableWidth: 200,
			cells: { data: (props) => <CellPopover {...props} /> },
		},
		{
			field: "netLiveWeightKg",
			title: t("Weight"),
			width: "140px",
			cells: {
				data: (props) => (
					<NumericalCell {...props} unit={"kg"} formatDecimal={2} />
				),

				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "price",
			title: t("Price"),
			width: "140px",
			cells: {
				data: (props) => (
					<NumericalCell {...props} unit={"kr"} formatDecimal={2} />
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "averagePrice",
			title: t("AveragePrice"),
			width: "120px",
			cells: {
				data: (props) => (
					<NumericalCell {...props} unit={"kr"} formatDecimal={2} />
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "msc",
			title: "msc",
			width: "100px",
		},
		{
			field: "information",
			title: t("Information"),
			cells: { data: (props) => <CellPopover {...props} /> },
		},
		{
			field: "buyerName",
			title: t("BuyerName"),
			cells: { data: (props) => <CellPopover {...props} /> },
		},
		{
			field: "salesDate",
			title: t("Date"),
			width: "110px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.salesDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "salesWeekDay",
			title: t("WeekDay"),
			width: "150px",
		},
		{
			field: "salesType",
			title: t("Type"),
			width: "150px",
			cells: { data: (props) => <CellPopover {...props} /> },
		},
	];
};

const NumericalHeader: FC<
	GridHeaderCellProps & { style?: React.CSSProperties } & any
> = (props) => {
	return (
		<th style={{ ...props.style, textAlign: "end", paddingRight: "10px" }}>
			{props.title}
		</th>
	);
};
